export default __webpack_public_path__ + "static/media/pig-old.4a9ccee4.svg";